export default {
  superUsers(state) {
    return state.superUsers;
  },
  searchResultUser(state) {
    return state.searchResultUser;
  },
};
